import { get } from '.';

export function GetVersions(options = {}) {
	return get<any>("/app/api/versions", options);
}

export function GetVersionSummary(options = {}) {
	return get<any>("/app/api/versions/summary", options);
}